var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userInfo.userType=='4')?_c('salesman'):_c('channel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }